import { LOAD_COMMON_DATA, LOADER, LOGIN_MODAL, SIGNUP_MODAL, LANGUAGE, LANGUAGES, TOP_PROGRESSBAR } from './types';
import { Product } from '../../api/resources/Product'
import { Extras } from '../../api/resources/Extras'

export const loadLanguageTranslations = (languageCode) => dispatch => {
    dispatch({
        type: TOP_PROGRESSBAR,
        payload: {topProgressBar: true}
	})
    Extras.getTranslations(languageCode)
        .then((res) => {
            if(res.data.status === 'success')
            {
                dispatch({
                    type: LANGUAGE,
                    payload: {
                        languageCode: res.data.data.language.code,
                        translations: res.data.data.language.translations
                    }
                })
            }
        })
        .finally(() => {
            dispatch({
                type: TOP_PROGRESSBAR,
                payload: {topProgressBar: false}
            })
        })
}

export const loadAvailableLanguages = (availableLanguages) => dispatch => {
    dispatch({
        type: LANGUAGES,
        payload: {
            availableLanguages: availableLanguages,
        }
    })
}



export const loadCommonData = (status) => dispatch => {
    const getData = async () => {
        try {
            const countriesRes = await Product.getCountries()
            const coalTypesRes = await Product.getCoalTypes()
            const mineCompaniesRes = await Product.getMineCompanies()
            const statesRes = await Product.getStates()
            const globalSettingsRes = await Product.getGlobalSettings()
            const paymentTermsRes = await Product.getPaymentTerms()
            const ekycIndustriesList = await Product.fetchEkycIndustries()

            dispatch({
                type: LOAD_COMMON_DATA,
                payload: {
                    countries: countriesRes.data.data,
                    coalTypes: coalTypesRes.data.data,
                    mineCompanies: mineCompaniesRes.data.data,
                    states: statesRes.data.data,
                    globalSettings: globalSettingsRes.data.data,
                    paymentTerms: paymentTermsRes.data.data.payment_terms,
                    ekycIndustries: ekycIndustriesList.data.data
                }
            })
        }
        catch(e) {
            console.error('Error loading common data.')
            console.error(e)
        }
    }
    getData()
}

export const loader = (status) => dispatch => {
    dispatch({
        type: LOADER,
        payload: {
            loader: status
        }
	})
}


export const updateLastSelectedBrandstoreValue = (value) => dispatch => {
    dispatch({
        type: 'LAST_SELECTED_BRANDSTORE',
        payload: value
	})
}

export const topProgressBarStatus = (status) => dispatch => {
    dispatch({
        type: TOP_PROGRESSBAR,
        payload: {
            topProgressBar: status
        }
	})
}

export const setLoginModal = (status) => dispatch => {
    dispatch({
        type: LOGIN_MODAL,
        payload: {
            loginModal: status
        }
	})
}

export const setSignupModal = (status) => dispatch => {
    dispatch({
        type: SIGNUP_MODAL,
        payload: {
            signupModal: status
        }
	})
}
